<template>
	<div>
		<egranty-input-field-popup
			:is-open.sync="addPriorityVisible"
			title="Dodaj nowy priorytet"
			label="Nazwa priorytetu"
			for="country-tab-name-priority"
			id="country-tab-name-priority"
			long
			@save="addPriority">
		</egranty-input-field-popup>

		<v-toolbar class="blue">
			<v-toolbar-title>Kraj ({{active[0].name}})</v-toolbar-title>
		</v-toolbar>

		<v-container>
			<div>
				<v-btn @click="addPriorityVisible = true"> Dodaj priorytet</v-btn>
				<v-btn v-if="!disableCopyPrioritiesButton" @click="copyPriorities(active[0])"> Kopiuj priorytety</v-btn>
				<v-btn v-if="!disablePastePrioritiesButton" @click="pastePriorities()"> Wklej priorytety</v-btn>
				<v-btn v-if="!disablePastePriorityButton" @click="pastePriority()"> Wklej priorytet</v-btn>
			</div>
			<div>
				<v-btn @click="copyCountry(active[0])"> Kopiuj kraj</v-btn>
			</div>
			<div>
				<v-btn
					color="lightred"
					v-if="!disabled"
					@click="deleteCountry(active[0].id)"> Usuń
				</v-btn>
				<v-btn @click="putHigher">
					<v-icon color="white">arrow_upward</v-icon>
				</v-btn>
				<v-btn @click="putLower">
					<v-icon color="white">arrow_downward</v-icon>
				</v-btn>
			</div>
		</v-container>
	</div>
</template>
<script>
	import {Task} from "@/api/generated/Task";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "CountryTab",
		components: {EgrantyInputFieldPopup},

		computed: {
			disableCopyPrioritiesButton(){
				return this.active[0].children.length == 0;
			},
			disablePastePrioritiesButton(){
				if(!this.copiedObject){
					return true;
				}
				if(!this.copiedObject.type || !this.copiedObject.id){
					return true;
				}
				if(this.copiedObject.type != "country"){
					return true;
				}
				if(this.copiedObject.id == this.active[0].id){
					return true;
				}
				return false;
			},
			disablePastePriorityButton(){
				if(!this.copiedObject){
					return true;
				}
				if(!this.copiedObject.type || !this.copiedObject.id){
					return true;
				}
				if(this.copiedObject.type != "priority"){
					return true;
				}
				if(this.copiedObject.id == this.active[0].id){
					return true;
				}
				if(this.copiedObject.onlyChildNodes){
					return true;
				}
				return false;
			}
		},

		methods: {
			getContestId() {
				return this.$route.params.id;
			},

			putHigher() {
				Task.postCountryHigherInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			putLower() {
				Task.postCountryLowerInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			addPriority(name) {
				Task.putPriority(this,
					this.active[0].id,
					name,
					() => {
						this.$emit("refresh");
						this.addPriorityVisible = false;
					});
			},

			deleteCountry(countryId) {
				Task.deleteTaskAccreditationCountry(this, countryId, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("removalError", errorResponse);
					}
				});
			},
			copyPriorities(country){
				let copiedObject = {
					type: country.type,
					id: country.id,
					onlyChildNodes: true
				};
				this.$emit("copyObject",copiedObject);
			},
			pastePriorities(){
				Task.postCopyCountryPriorities(this, this.active[0].id , this.copiedObject.id, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("copyError", errorResponse);
					}
				});
			},
			pastePriority(){
				Task.postCopyCountryPriority(this, this.active[0].id , this.copiedObject.id, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("copyError", errorResponse);
					}
				});
			},
			copyCountry(country){
				let copiedObject = {
					type: country.type,
					id: country.id,
					onlyChildNodes: false
				};
				this.$emit("copyObject",copiedObject);
			},

		},

		data() {
			return {
				addPriorityVisible: false,
			};
		},

		props: {
			active: {},
			disabled: {type: Boolean, default: false},
			copiedObject: {
				type: Object,
				default: function () {
					return {};
				},
			}
		},
	};
</script>
